import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { useQueryParamState } from '#/hooks/useQueryParamState';
import { useTrackPageView } from '#/hooks/useTrackPageView';

import { ForgotPasswordPage } from './ForgotPasswordPage';

export function ForgotPasswordPageContainer() {
  const location = useLocation<{ email?: string }>();

  useTrackPageView('Forgot Password', {
    page_type: 'Forgot Password',
  });

  const [emailFromQuery] = useQueryParamState({ name: 'email' });

  const email = useMemo(
    () => emailFromQuery ?? location.state?.email,
    [emailFromQuery, location.state],
  );

  return <ForgotPasswordPage email={email} />;
}
